angular
  .module('cfn')
  .controller('stockyardMaskController', stockyardMaskController);

stockyardMaskController.$inject = [
  '$scope',
  '$log',
  '$route',
  '$rootScope',
  '$location',
  '$timeout',
  'i18nFilter',
  'BookingOperations',
  'bookingRules',
  'bookingService',
  'CfnDialogService',
  'storage',
  'timeZoneHackService'
];
function stockyardMaskController(
  $scope,
  $log,
  $route,
  $rootScope,
  $location,
  $timeout,
  i18nFilter,
  BookingOperations,
  bookingRules,
  bookingService,
  CfnDialogService,
  storage,
  timeZoneHackService
) {
  // Private ==============================================

  // collect and return data from all elements (Zugang/Abgang/Handelspartner)
  var getModel = function() {
      var serverData = {
        // BE needs all this stuff!!
        id: $scope.model.id,
        version: $scope.model.version,
        bookingSection: 'STOCKYARD',
        date: null,
        toDate: null,
        endDate: null,
        activityName: $scope.model.activity
          ? $scope.model.activity.name
          : 'OUTGOING',
        allDay: true,
        state: 'BOOKED',
        assets: [],
        supplies: [],
        supplyProportions: [],
        products: [],
        productProportions: [],
        resources: []
      };
      if ($scope.model.date) {
        var calBackendDate = timeZoneHackService.toBackendTimezone(
          new Date($scope.model.date)
        );
        serverData.date = calBackendDate;
        serverData.toDate = calBackendDate;
        serverData.endDate = calBackendDate;
      }

      // Fill $scope.details with data (Fertilizer, Seed, ...) from all elements (Partner, StockyardOutgoing,...)
      if ($scope.model.activity) {
        angular.forEach($scope.model.activity.elements, function(
          element,
          elementName
        ) {
          if (element.active) {
            var elementScope = angular
              .element('#' + elementName + '_booking_ele')
              .scope();
            if (elementScope && elementScope.prepareSave) {
              elementScope.prepareSave(elementName, serverData);
            }
          }
        });
      }
      return serverData;
    },
    // Fill scope.model (and all controlled elements) with data
    setModel = function(data) {
      $scope.model.date = timeZoneHackService.toClientTimezone(data.date);
      $scope.model.id = data.id;
      $scope.model.version = data.version;

      // Set loaded activity
      $scope.setActivity(bookingRules.stockyard.activities[data.activityName]);

      // Inform all elements (Partner, StockyardOutgoing,...) to load data (Fertilizer, Seed, ...) from server
      // Better: Pub/Sub from elements to Controller
      if ($scope.model.activity) {
        angular.forEach($scope.model.activity.elements, function(
          element,
          elementName
        ) {
          var elementScope = angular
            .element('#' + elementName + '_booking_ele')
            .scope();
          if (elementScope && elementScope.prepareLoad) {
            elementScope.prepareLoad(data.activityName, data);
          }
        });
      }
    };

  // Model =================================================

  // for ng-repeat in stockyardMask.html
  $scope.rules = bookingRules.stockyard;

  $scope.model = {
    date: null, // booking-date
    id: null, // current loaded booking guid (or null)
    version: null, // id-version
    activity: null // current activity ()
  };

  // Bind date to localstorage
  storage.bind($scope, 'model.date', {
    defaultValue: new Date().getTime(),
    storeName: 'stockyardMaskDate'
  });

  // Scope-Functions ========================================

  $scope.isValidForBackend = function() {
    return true;
    // var beModel = getModel();
    // any non empty supplies or products?
    // return beModel.supplies.some(function (value) { return value.amount; }) ||
    //        beModel.products.some(function (value) { return value.amount; });
  };

  // Set Activity (Zugang/Abgang) activity:object
  $scope.setActivity = function(activity) {
    $scope.model.activity = activity;

    // Set current activity activ, all other inactive
    angular.forEach(bookingRules.stockyard.activities, function(act, actName) {
      act.active = act == activity;
    });

    // Set all elements inactive
    angular.forEach(bookingRules.stockyard.elements, function(element) {
      element.active = false;
    });

    // Active Elements for activity
    if ($scope.model.activity) {
      angular.forEach($scope.model.activity.elements, function(element) {
        element.active = true;
      });
    }
  };

  $scope.delete = function() {
    if ($scope.model.id)
      CfnDialogService.confirm(function() {
        BookingOperations.delete({ id: $scope.model.id }, function(result) {
          $location.path('/booking/stockyard'); //load clean mask
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.common.message.successfullyDeleted',
              'erfolgreich gelöscht'
            ),
            'success'
          );
        });
      });
  };

  $scope.submit = function() {
    // Send data to Server
    app.startLoading();
    BookingOperations.save(null, getModel(), function(result) {
      app.finishLoading();
      if (result) {
        $rootScope.handleMsgContext(result.messagingContext);
        if (result.success) {
          $scope.clear();
          $location.path('/booking/stockyard'); //load clean mask
          // load complete new location (to set correct URL)
          // $location.path('/booking/stockyard/' + result.object.id);
          // alternative (without set Browser-URL): setModel(result.object);
        }
      }
    });
  };

  $scope.loadById = function(id) {
    app.startLoading();
    BookingOperations.get({ id: id }, function(result) {
      app.finishLoading();
      if (result.bookingSection !== 'STOCKYARD')
        // Oh! This result is not for me, go away
        $location.path(
          '/booking/' + result.bookingSection.toLowerCase() + '/' + id
        );
      setModel(result);
    });
  };

  $scope.clear = function() {
    // Inform all elements (Field, Seed,...) to clear elements
    if ($scope.model.activity) {
      angular.forEach($scope.model.activity.elements, function(
        element,
        elementName
      ) {
        var elementScope = angular
          .element('#' + elementName + '_booking_ele')
          .scope();
        if (elementScope.onClear) {
          elementScope.onClear();
        }
      });
    }
    $scope.setActivity(null);
    $scope.model = {
      // Save the date
      date: $scope.model.date
    };
    $rootScope.allowNavigation();
  };

  // Init ====================================================

  // goToCore-Event will send from parent-Scopes (StockyardTable.js or PartnerTable.js)
  $scope.$on('goToCore', function(event, url) {
    app.gotoWithBackButton(
      url,
      $location.path(), // backlink
      i18nFilter('fe.stockyard.mask.back', 'zurück zur Lagerbuchung'), //
      'stockyardMaskController',
      getModel()
    );
  });

  $timeout(function() {
    // one angular-digest for dynamic booking-elements

    // Welcome back from core (see goToCore)
    if (
      $rootScope.goBackState &&
      $rootScope.goBackState.type === 'stockyardMaskController'
    ) {
      $rootScope.alertController.closeAlert();
      $rootScope.alertController.addTemporaryAlert(
        i18nFilter('fe.booking.continue.message', 'Buchung wird fortgesetzt'),
        'success'
      );
      bookingService
        .updateEntityReadOnlyFields($rootScope.goBackState.data)
        .then(function() {
          setModel($rootScope.goBackState.data);
          $rootScope.goBackState = null;
        });
    } else {
      // Jump from List with UUID in URL
      if ($route.current.params.id) {
        $scope.loadById($route.current.params.id);
      } else {
        // Reset activities
        bookingRules.setAllActiveActivities('STOCKYARD', []);
      }
    }
  }, 0);
}
